/* eslint-disable react-hooks/exhaustive-deps */
import {
  Grid,
  Card,
  Container,
  Box,
  CardHeader,
  Button,
  ButtonGroup,
  Switch,
  Typography,
  Stack,
  // ToggleButton,
  // ToggleButtonGroup
} from '@mui/material';
import { useEffect, useState, useRef } from 'react';
import StreamManager from 'vst-streaming-lib';
import './webrtcVideo.css';


function Webrtc() {
  const streamManger = useRef();
  const [enableDummyUDP, setEnableDummyUDP] = useState(false);
  const [enableCamera, setEnableCamera] = useState(true);
  const [enableMicrophone, setEnableMicrophone] = useState(true);
  // const [streamType, setStreamType] = useState('streambridge');

  // const handleStreamType = (event, type) => {
  //   console.log("stream type: ", type);
  //   setStreamType(type);
  // };

  const handleDummyUDP = (event) => {
    setEnableDummyUDP(event.target.checked);
  };

  const handleCamera = (event) => {
    console.log("camera: ", event.target.checked);
    setEnableCamera(event.target.checked);
  };

  const handleMicrophone = (event) => {
    console.log("microphone: ", event.target.checked);
    setEnableMicrophone(event.target.checked);
  };

  useEffect(() => {
    const startStreaming = async () => {
      if (!enableCamera && !enableMicrophone) {
        alert("Enable either camera or microphone or both");
        return;
      }

      if (streamManger.current) {
        alert("Stop existing stream first");
        return;
      }
      streamManger.current = new StreamManager();
      streamManger.current.updateConfig({
        inboundStreamVideoElementId: 'tokkio-avatar-stream',
        outboundStreamVideoElementId: 'webcam-stream',
        enableMicrophone,
        enableCamera,
        streamType: 'streambridge',
        enableWebsocketPing: true,
        enableLogs: true,
        enableDummyUDPCall: enableDummyUDP,
      })

      streamManger.current.startStreaming();
    }

    const stopStreaming = async () => {
      if (streamManger.current) {
        await streamManger.current.stopStreaming();
        streamManger.current = null;
      }
    }

    const addStartButtonClickListener = () => {
      document
        .getElementById("tokkio-stream-start-button")
        ?.addEventListener('click', startStreaming);
    }

    const addStopButtonClickListener = () => {
      document
        .getElementById("tokkio-stream-stop-button")
        ?.addEventListener('click', stopStreaming);
    }
    addStartButtonClickListener();
    addStopButtonClickListener();

    return () => {
      document
        .getElementById("tokkio-stream-start-button")
        ?.removeEventListener('click', startStreaming);
      document
        .getElementById("tokkio-stream-stop-button")
        ?.removeEventListener('click', stopStreaming);
    };
  }, [enableMicrophone, enableCamera, enableDummyUDP])

  return (
    <Container maxWidth="xl">
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardHeader title={'Tokkio Avatar Stream'} subheader={'Tokkio Avatar Stream'} />
            <Box sx={{ p: 3 }}>
              <video width="100%" height="auto" autoPlay controls muted id="tokkio-avatar-stream" />
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardHeader title={'Webcam Stream'} subheader={'Webcam Stream'} />
            <Box sx={{ p: 3 }}>
              <video width="100%" height="auto" autoPlay controls muted id="webcam-stream" />
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardHeader title={'Controls'} subheader={'Stream Controls'} />
            <Box sx={{ p: 3 }}>
              <ButtonGroup
                variant="contained"
                fullWidth
              >
                <Button id="tokkio-stream-start-button">Start</Button>
                <Button id="tokkio-stream-stop-button">Stop</Button>
                <Button id="tokkio-debug-stream-button" disabled>Debug Stream Trigger</Button>
              </ButtonGroup>
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <Box sx={{ pb: 3 }}>
              <CardHeader title={'Options'} subheader={'Stream Options'} />
              <Stack sx={{ pl: 3 }} direction="row" spacing={1} alignItems="center">
                <Typography>
                  Dummy UDP stream:
                </Typography>
                <Switch
                  checked={enableDummyUDP}
                  onChange={handleDummyUDP}
                // disabled={streamType !== 'streambridge'}
                />
              </Stack>
              <Stack sx={{ pl: 3 }} direction="row" spacing={1} alignItems="center">
                <Typography>
                  Enable Camera:
                </Typography>
                <Switch
                  checked={enableCamera}
                  onChange={handleCamera}
                // disabled={streamType !== 'streambridge'}
                />
              </Stack>
              <Stack sx={{ pl: 3 }} direction="row" spacing={1} alignItems="center">
                <Typography>
                  Enable Microphone:
                </Typography>
                <Switch
                  checked={enableMicrophone}
                  onChange={handleMicrophone}
                // disabled={streamType !== 'streambridge'}
                />
              </Stack>
              {/* <Stack sx={{ pl: 3 }} direction="row" spacing={1} alignItems="center">
              <ToggleButtonGroup
                color="primary"
                exclusive
                onChange={handleStreamType}
                value={streamType}
              >
                <ToggleButton value="streambridge">StreamBridge</ToggleButton>
                <ToggleButton value="live">Live</ToggleButton>
                <ToggleButton value="replay">Replay</ToggleButton>
              </ToggleButtonGroup>
            </Stack> */}
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Webrtc;
